module.exports = __webpack_public_path__ + "static/media/go.f3bb2609.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/go.png
// module id = 104
// module chunks = 0